var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20InfoCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5838_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 2.00005C4.68634 2.00005 2.00005 4.68634 2.00005 8.00005C2.00005 11.3138 4.68634 14 8.00005 14C11.3138 14 14 11.3138 14 8.00005C14 4.68634 11.3138 2.00005 8.00005 2.00005ZM0.800049 8.00005C0.800049 4.0236 4.0236 0.800049 8.00005 0.800049C11.9765 0.800049 15.2 4.0236 15.2 8.00005C15.2 11.9765 11.9765 15.2 8.00005 15.2C4.0236 15.2 0.800049 11.9765 0.800049 8.00005ZM8.00005 4.00005C8.33142 4.00005 8.60005 4.26868 8.60005 4.60005V5.80005C8.60005 6.13142 8.33142 6.40005 8.00005 6.40005C7.66868 6.40005 7.40005 6.13142 7.40005 5.80005V4.60005C7.40005 4.26868 7.66868 4.00005 8.00005 4.00005ZM8.00005 8.00005C8.33142 8.00005 8.60005 8.26868 8.60005 8.60005V11.4C8.60005 11.7314 8.33142 12 8.00005 12C7.66868 12 7.40005 11.7314 7.40005 11.4V8.60005C7.40005 8.26868 7.66868 8.00005 8.00005 8.00005Z",
    fill: "#182BCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5838_1619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20InfoCircle);
export default __webpack_public_path__ + "static/media/20-info-circle.c8c2c502ad687c90d3ca37f9f7046485.svg";
export { ForwardRef as ReactComponent };